import { useProposalT } from "../i18n/ProposalI18nContext";
import { SUPPORTED_LOCALES, LOCALE_FLAGS, LOCALE_LABELS } from "../i18n/types";
import type { ProposalLocale } from "../i18n/types";

interface LanguageSelectorProps {
  variant?: "light" | "dark";
}

export function LanguageSelector({ variant = "light" }: LanguageSelectorProps) {
  const { locale, setLocale } = useProposalT();

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "2px",
        padding: "3px",
        borderRadius: "999px",
        background:
          variant === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)",
        border:
          variant === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.08)",
      }}
    >
      {SUPPORTED_LOCALES.map((loc: ProposalLocale) => {
        const isActive = loc === locale;
        return (
          <button
            key={loc}
            onClick={() => setLocale(loc)}
            style={{
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "11px",
              fontWeight: isActive ? 700 : 500,
              border: "none",
              cursor: "pointer",
              transition: "all 0.2s",
              background: isActive
                ? variant === "dark"
                  ? "rgba(255,255,255,0.2)"
                  : "white"
                : "transparent",
              color:
                variant === "dark"
                  ? isActive
                    ? "white"
                    : "rgba(255,255,255,0.6)"
                  : isActive
                    ? "#1A1814"
                    : "#78736D",
              boxShadow: isActive ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
              lineHeight: 1,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: "3px",
            }}
          >
            <span style={{ fontSize: "12px" }}>{LOCALE_FLAGS[loc]}</span>
            {LOCALE_LABELS[loc]}
          </button>
        );
      })}
    </div>
  );
}
